import { Formik, Field } from 'formik';
import React from 'react';
import { Form, Button } from 'semantic-ui-react';

import FormikInput from '../FormikInput';
import { Plant, PlantUpdate } from '../../../../src/types';

type SettingsFormProps = { 
    plant: Plant, 
    onSubmit: (plant:PlantUpdate) => void
    cancel: Function
}

const SettingsForm = ({ plant, onSubmit, cancel }: SettingsFormProps) => {
    const initialValues = {
        name: plant.name,
        dryValue: plant.dryValue,
        wetValue: plant.wetValue,
        valve: plant.valve,
        channel: plant.channel,
        minimumTolerance: plant.minimumTolerance,
        setPoint: plant.setPoint,
        pumpTime: plant.pumpTime,
        water_volume_threshold: plant.water_volume_threshold
    }

    return (
        <Formik initialValues={initialValues} onSubmit={onSubmit}>
            {({handleSubmit}) => 
                <Form onSubmit={handleSubmit}>
                    <Form.Group widths="equal">
                        <Field
                            label="name"
                            name="name"
                            placeholder={plant.name}
                            component={FormikInput}
                            type="text"
                            value={plant.name}
                        />
                        <Field
                            label="dry value"
                            name="dryValue"
                            placeholder={plant.dryValue}
                            component={FormikInput}
                            type="number"
                            value={plant.dryValue}
                        />
                        <Field
                            label="wet value"
                            name="wetValue"
                            placeholder={plant.wetValue}
                            component={FormikInput}
                            type="number"
                            value={plant.wetValue}
                        />
                        <Field
                            label="valve"
                            name="valve"
                            placeholder={plant.valve}
                            component={FormikInput}
                            type="number"
                            value={plant.valve}
                        />
                        <Field
                            label="channel"
                            name="channel"
                            placeholder={plant.channel}
                            component={FormikInput}
                            type="number"
                            value={plant.channel}
                        />
                        <Field
                            label="minimum tolerance"
                            name="minimumTolerance"
                            placeholder={`${plant.minimumTolerance}%`}
                            component={FormikInput}
                            type="number"
                            value={plant.minimumTolerance}
                        />
                        <Field
                            label="set point"
                            name="setPoint"
                            placeholder={`${plant.setPoint}%`}
                            component={FormikInput}
                            type="number"
                            value={plant.setPoint}
                        />
                        <Field
                            label="pump time"
                            name="pumpTime"
                            placeholder={`${plant.minimumTolerance} seconds`}
                            component={FormikInput}
                            type="number"
                            step={0.1}
                            value={plant.minimumTolerance}
                        />
                        <Field
                            label="water volume threshold"
                            name="water_volume_threshold"
                            placeholder={`${plant.water_volume_threshold} L`}
                            component={FormikInput}
                            type="number"
                            step={0.1}
                            value={plant.water_volume_threshold}
                        />
                        <Field
                            label="image url"
                            name="imageURL"
                            placeholder="eg. https://upload.wikimedia.org/wikipedia/commons/3/33/Calathea_lancifolia_bb2_%28edit%29.jpg"
                            component={FormikInput}
                            type="text"
                            value={plant.imageURL}
                        />
                    </Form.Group>
                    <Button.Group>
                        <Button type="submit" color="teal">Save</Button>
                        <Button.Or />
                        <Button onClick={() => cancel()}>Cancel</Button>
                    </Button.Group>
                </Form>
            }
        </Formik>
    )
}

export default SettingsForm